import { z } from "zod";

export const TRADE_TYPE = {
  WORKFORCE: "WORKFORCE",
  EQUIPMENT: "EQUIPMENT",
} as const;

export const tradeTypeSchema = z.enum(["WORKFORCE", "EQUIPMENT"]);

export const projectTradeItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: tradeTypeSchema,
});

export const projectTradesResponseSchema = z.object({
  results: z.array(projectTradeItemSchema),
});

export type TradeType = z.infer<typeof tradeTypeSchema>;
export type ProjectTradeItem = z.infer<typeof projectTradeItemSchema>;
export type ProjectTradesResponse = z.infer<typeof projectTradesResponseSchema>;
